const COMMON_PREFIX = '@defign';
const LOG_MODE = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  NONE: 'none'
};
const NF_SERVICE_TYPE = {
  MY_ASSET: 'myAsset',
  PAYMENT: 'payment',
  FINANCE: 'finance',
  STOCK: 'stock',
  REAL_ESTATE: 'realEstate'
};
const NF_HEADER_TYPE = {
  MAIN: 'main',
  DEPTH: 'depth'
};
const NF_HEADER_SERVICE_TYPE = {
  ...NF_SERVICE_TYPE,
  INSURANCE: 'insurance'
};
const NF_SERVICE_INFO = {
  [NF_SERVICE_TYPE.MY_ASSET]: {
    text: '내 자산',
    href: '/mydata/home'
  },
  [NF_SERVICE_TYPE.PAYMENT]: {
    text: '결제',
    href: '/historybenefit/home'
  },
  [NF_SERVICE_TYPE.FINANCE]: {
    text: '금융',
    href: '/finance'
  },
  [NF_SERVICE_TYPE.STOCK]: {
    text: '증권',
    href: '/'
  },
  [NF_SERVICE_TYPE.REAL_ESTATE]: {
    text: '부동산',
    href: '/'
  }
};
const NF_HEADER_SERVICE_INFO = {
  ...NF_SERVICE_INFO,
  [NF_HEADER_SERVICE_TYPE.INSURANCE]: {
    text: '보험',
    href: '/'
  }
};
const BADGE_TYPE = {
  DOT: 'dot',
  NEW: 'new'
};
const RESPONSIVE = {
  MOBILE: 320,
  TABLET: 600,
  DESKTOP: 1152
};

export { BADGE_TYPE, COMMON_PREFIX, LOG_MODE, NF_HEADER_SERVICE_INFO, NF_HEADER_SERVICE_TYPE, NF_HEADER_TYPE, NF_SERVICE_INFO, NF_SERVICE_TYPE, RESPONSIVE };
